import { useState } from 'react'
import { Phone, Loader2 } from 'lucide-react'
import { useCallStore } from '../stores/callStore'
import { useTwilioDevice } from '../hooks/useTwilioDevice'
import { formatPhoneNumberForDisplay } from '../utils/phoneNumberHelper'
import { logger } from '../utils/logger'

/**
 * 転送割り当てバナー
 *
 * pendingTransfer がセットされている（WebSocketで転送通知を受信済み）かつ
 * 通話中でない場合に表示される。
 * ユーザーが「接続」をクリックすると device.connect() で保留キューに接続する。
 */
export default function PendingTransferBanner() {
  const pendingTransfer = useCallStore((state) => state.pendingTransfer)
  const callStatus = useCallStore((state) => state.callStatus)
  const internalCallStatus = useCallStore((state) => state.internalCallStatus)

  const { connectPendingTransfer } = useTwilioDevice()

  const [connecting, setConnecting] = useState(false)

  // 転送待ちがない、または通話中の場合は非表示
  if (!pendingTransfer) return null
  if (callStatus !== 'idle') return null
  if (internalCallStatus !== 'idle') return null

  const handleConnect = async () => {
    setConnecting(true)
    try {
      await connectPendingTransfer()
    } catch (error) {
      logger.error('[PendingTransferBanner] 接続エラー:', error)
      alert(`転送通話への接続に失敗しました: ${(error as Error).message}`)
    } finally {
      setConnecting(false)
    }
  }

  return (
    <div className="fixed top-16 left-1/2 -translate-x-1/2 z-50 animate-slide-down">
      <div className="bg-blue-600 text-white rounded-xl shadow-2xl px-6 py-4 flex items-center gap-4">
        <Phone className="w-5 h-5 animate-pulse" />
        <div>
          <div className="text-sm font-semibold">転送通話が割り当てられました</div>
          <div className="text-xs text-blue-100">
            {formatPhoneNumberForDisplay(pendingTransfer.callerNumber)}
          </div>
        </div>
        <button
          onClick={handleConnect}
          disabled={connecting}
          className="ml-4 px-4 py-2 bg-white text-blue-600 font-semibold rounded-lg hover:bg-blue-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {connecting ? (
            <span className="flex items-center gap-2">
              <Loader2 className="w-4 h-4 animate-spin" />
              接続中...
            </span>
          ) : (
            '接続'
          )}
        </button>
      </div>
    </div>
  )
}
